/**
 * Guest-realm source for the Documents extension. Like Task Manager, this
 * panel is host-rendered (DocumentsSidebar.js + DocumentEditorTab.js) and
 * reads/writes records directly via Tauri invoke(), bypassing the guest
 * sandbox. This entry script is a no-op kept only to satisfy the extension
 * registration contract (every extension needs a valid entry).
 */
export const documentsEntrySource = `
(function () {
  var sdk = window.apibooSDK;
  sdk.onActivate(function () {});
})();
`;
